/* =========================
   LX IMPACT HERO
========================= */

(function () {
  'use strict';

  const heroSections = document.querySelectorAll('.lx-impact-hero');

  if (!heroSections.length) return;

  heroSections.forEach((section) => {

    const buttons = section.querySelectorAll('.lx-impact-hero__btn');

    buttons.forEach((button) => {

      button.addEventListener('mouseenter', () => {
        button.style.transform = 'translateY(-1px)';
      });

      button.addEventListener('mouseleave', () => {
        button.style.transform = '';
      });

    });

  });

})();
/* =========================
   LX IMPACT BRANDS
========================= */

(function () {

  const sections = document.querySelectorAll('.lx-impact-brands');

  if (!sections.length) return;

  sections.forEach((section) => {

    const track = section.querySelector('[data-slider-track]');
    const prev = section.querySelector('[data-slider-prev]');
    const next = section.querySelector('[data-slider-next]');

    if (!track || !prev || !next) return;

    let index = 0;

    const gap = window.innerWidth >= 768 ? 24 : 16;
    const cardWidth = 144;

    const items = track.querySelectorAll('.lx-impact-brands__item');

    function visibleCount() {
      const viewportWidth = track.parentElement.offsetWidth;
      return Math.floor((viewportWidth + gap) / (cardWidth + gap));
    }

    function maxIndex() {
      return Math.max(0, items.length - visibleCount());
    }

    function updateSlider() {

      const offset = index * (cardWidth + gap);

      track.style.transform = `translateX(-${offset}px)`;

      prev.disabled = index <= 0;
      next.disabled = index >= maxIndex();

    }

    prev.addEventListener('click', () => {

      if (index <= 0) return;

      index--;

      updateSlider();

    });

    next.addEventListener('click', () => {

      if (index >= maxIndex()) return;

      index++;

      updateSlider();

    });

    window.addEventListener('resize', () => {

      if (index > maxIndex()) {
        index = maxIndex();
      }

      updateSlider();

    });

    updateSlider();

  });

})();
/* =========================
   LX IMPACT PORTFOLIO
========================= */

(function () {

  const sections = document.querySelectorAll('.lx-impact-portfolio');

  if (!sections.length) return;

  sections.forEach((section) => {

    const slider = section.querySelector('[data-portfolio-slider]');
    const prev = section.querySelector('[data-portfolio-prev]');
    const next = section.querySelector('[data-portfolio-next]');

    if (!slider || !prev || !next) return;

    function updateButtons() {

      const atStart = slider.scrollLeft <= 2;

      const atEnd =
        slider.scrollLeft >=
        slider.scrollWidth - slider.clientWidth - 2;

      prev.disabled = atStart;
      next.disabled = atEnd;

    }

    function getScrollAmount() {

      if (window.innerWidth >= 768) {
        return 336;
      }

      const card = slider.querySelector('.lx-impact-portfolio__card');

      if (!card) return 200;

      return card.offsetWidth + 12;

    }

    prev.addEventListener('click', () => {

      slider.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });

    });

    next.addEventListener('click', () => {

      slider.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });

    });

    slider.addEventListener(
      'scroll',
      updateButtons,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      updateButtons
    );

    requestAnimationFrame(updateButtons);

  });

})();
/* =========================
   LX IMPACT REVIEWS
========================= */

(function () {

  const sections = document.querySelectorAll('.lx-impact-reviews');

  if (!sections.length) return;

  sections.forEach((section) => {

    const slider = section.querySelector('[data-reviews-slider]');
    const prev = section.querySelector('[data-reviews-prev]');
    const next = section.querySelector('[data-reviews-next]');

    if (!slider || !prev || !next) return;

    function updateButtons() {

      const atStart = slider.scrollLeft <= 2;

      const atEnd =
        slider.scrollLeft >=
        slider.scrollWidth - slider.clientWidth - 2;

      prev.disabled = atStart;
      next.disabled = atEnd;

    }

    function getScrollAmount() {

      if (window.innerWidth >= 768) {
        return 336;
      }

      const card = slider.querySelector('.lx-impact-reviews__card');

      if (!card) return 220;

      return card.offsetWidth + 12;

    }

    prev.addEventListener('click', () => {

      slider.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });

    });

    next.addEventListener('click', () => {

      slider.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });

    });

    slider.addEventListener(
      'scroll',
      updateButtons,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      updateButtons
    );

    requestAnimationFrame(updateButtons);

  });

})();
/* =========================
   LX IMPACT CONTACT FORM
========================= */

(function () {

  const sections = document.querySelectorAll('.lx-impact-contact-form');

  if (!sections.length) return;

  sections.forEach((section) => {

    const form = section.querySelector('form');

    if (!form) return;

    const inputs = form.querySelectorAll(
      'input[required], textarea[required]'
    );

    const submitButton = form.querySelector(
      '[data-contact-submit]'
    );

    const resetButton = form.querySelector(
      '[data-contact-reset]'
    );

    function validateForm() {

      let valid = true;

      inputs.forEach((field) => {

        if (!field.value.trim()) {
          valid = false;
        }

        if (
          field.type === 'email' &&
          field.value.trim()
        ) {

          const emailPattern =
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

          if (!emailPattern.test(field.value.trim())) {
            valid = false;
          }

        }

      });

      submitButton.disabled = !valid;

      if (valid) {
        submitButton.classList.add(
          'lx-impact-contact-form__btn--active'
        );
      } else {
        submitButton.classList.remove(
          'lx-impact-contact-form__btn--active'
        );
      }

    }

    inputs.forEach((field) => {

      field.addEventListener(
        'input',
        validateForm
      );

    });

    if (resetButton) {

      resetButton.addEventListener('click', () => {

        form.reset();

        validateForm();

      });

    }

    validateForm();

  });

})();
/* =========================
   LX IMPACT FAQ
========================= */

(function () {

  const sections = document.querySelectorAll('.lx-impact-faq');

  if (!sections.length) return;

  sections.forEach((section) => {

    const items = section.querySelectorAll(
      '.lx-impact-faq__item'
    );

    items.forEach((item) => {

      const button = item.querySelector(
        '.lx-impact-faq__question'
      );

      if (!button) return;

      button.addEventListener('click', () => {

        const isOpen =
          item.classList.contains('is-open');

        items.forEach((el) => {

          el.classList.remove('is-open');

          const btn = el.querySelector(
            '.lx-impact-faq__question'
          );

          if (btn) {
            btn.setAttribute(
              'aria-expanded',
              'false'
            );
          }

        });

        if (!isOpen) {

          item.classList.add('is-open');

          button.setAttribute(
            'aria-expanded',
            'true'
          );

        }

      });

    });

  });

})();